<app-configuration-datasource *ngIf="dataSourceInstance" [dataSourceInstance]="dataSourceInstance"
  [highlightSelected]="true" [sortByName]="true" (onTreeNodeSelect)="onSelectTreeNode($event)">
</app-configuration-datasource>
